import { render, staticRenderFns } from "./InventoryPageAttributes.vue?vue&type=template&id=2c1504cf"
import script from "./InventoryPageAttributes.vue?vue&type=script&lang=js"
export * from "./InventoryPageAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports